import React, { useState, useEffect } from 'react';
import {
  Card,
  Button,
  Input,
  Space,
  Tag,
  Modal,
  Tabs,
  Row,
  Col,
  Statistic,
  Timeline,
  List,
  Badge,
  Divider,
  message,
  Form,
  Select,
  Switch,
  InputNumber,
  Alert,
  Steps,
  Radio,
  Progress,
  Tooltip,
  Descriptions,
  Table,
} from 'antd';
import {
  BugOutlined,
  PlayCircleOutlined,
  EyeOutlined,
  ApiOutlined,
  BarChartOutlined,
  SendOutlined,
  ReloadOutlined,
  ExportOutlined,
  ImportOutlined,
  FilterOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  ClockCircleOutlined,
  SettingOutlined,
  DownloadOutlined,
} from '@ant-design/icons';

const { TextArea } = Input;

const DebugTools: React.FC = () => {
  const [simulateModalVisible, setSimulateModalVisible] = useState(false);
  const [traceModalVisible, setTraceModalVisible] = useState(false);
  const [abTestModalVisible, setAbTestModalVisible] = useState(false);
  const [settingsModalVisible, setSettingsModalVisible] = useState(false);
  const [userInput, setUserInput] = useState('');
  const [conversationHistory, setConversationHistory] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState('all');
  const [testMode, setTestMode] = useState('single');
  const [abTestProgress, setAbTestProgress] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();

  // 话术库 - 根据bot类型返回相应话术
  const getBotResponse = (userMessage: string, agentType: string): string => {
    const lowerMessage = userMessage.toLowerCase();
    
    // 直播间活跃机器人（普通观众）话术
    const liveRoomScripts = [
      "哇，今天人好多啊！",
      "来晚了来晚了，开始了吗？",
      "兄弟们好！今天手气怎么样？",
      "看直播的各位，晚上好！",
      "主播在吗？今天播什么游戏？",
      "666666！",
      "牛啊！这把稳了！",
      "哈哈哈哈哈",
      "卧槽！这也行？",
      "羡慕了羡慕了",
      "大佬带带我！",
      "这波稳了！",
      "我也想中啊！",
      "天啊！中了！",
      "这运气绝了！",
      "我去，这么准？",
      "又中了？今天什么情况？",
      "太刺激了吧！",
      "不敢相信！",
      "真的假的？！",
      "有老哥能说说这个怎么玩吗？",
      "这游戏中奖率怎么样啊？",
      "刚才那个投注多少啊？",
      "有跟着投的吗？",
      "今天谁赢得最多？",
      "新手适合玩这个吗？",
      "哈哈，我中了500！",
      "完了，今天又亏了",
      "不玩了不玩了，气死我了",
      "冷静冷静，还有机会",
      "今天手气不错，再来一把！",
      "我就知道不该投这么多",
      "赚了赚了，收手！",
      "快开快开！",
      "紧张！要开奖了！",
      "下一把下一把！",
      "等不及了，赶紧的！",
      "这把感觉能中！",
      "快快快，要开了！",
      "我跟了！",
      "跟大神，准没错！",
      "我也梭哈了！",
      "这把我也压100！",
      "跟了跟了，稳赚！",
      "刚才中了1000，开心！",
      "今天已经赢了2000了，收手！",
      "这个游戏真的能赚钱啊！",
      "跟着大神投的，稳赚！",
      "看我的战绩！",
      "怎么没人说话了？",
      "大家都在看吗？扣个1",
      "我觉得下一把有机会！",
      "有一起玩的吗？",
      "刚才没看到，发生什么了？",
      "大家别走啊，马上开奖了！",
      "大家觉得这个游戏怎么样？",
      "有没有人玩过这个游戏？",
      "今天谁的运气最好？",
      "什么时候抽奖啊？",
      "有没有大神分享经验？"
    ];

    // 主播带单机器人（售前客服）话术
    const hostScripts = [
      "欢迎新朋友来到直播间！这里是游戏专场，新朋友可以先观摩一下，有问题随时问我！",
      "哈喽！看你是新来的，我给你简单介绍下这个游戏的玩法...点击我头像可以看详细攻略！",
      "新用户今天有首充优惠哦，充100送50，详情点击右上角活动！",
      "大家欢迎新朋友！新人有专属礼包可以领，点我头像就能看到！",
      "你好！我是这个直播间的助手，有任何问题都可以问我，我会手把手教你哦！",
      "好久不见！欢迎回来，这段时间上线了很多新游戏，一会给你讲讲！",
      "老朋友有回归礼包200元，记得领取哦！",
      "你终于来了，刚才有人中了大奖，你来得正好！",
      "欢迎老朋友回归！你的VIP等级还保留着，专属福利继续享受！",
      "【超级王牌】玩法讲解：这是一款5×4卷轴老虎机，1024条获胜线路。只要3个以上相同图标连线就能中奖，中奖率非常高！推荐新手从100元起投！",
      "这个游戏的核心是'连击'，你看刚才有人就是连击5次，一把赚了2000+！所以下注要有耐心，等待连击时刻！",
      "给大家分析一下当前走势：最近10局中奖8次，出奖率80%！现在是入场的好时机！",
      "这个游戏有三个特殊符号：Wild(万能)、Scatter(分散)、Bonus(奖励)，出现这些符号中奖概率会翻倍！",
      "新手建议：先从小额开始，熟悉游戏规则后再加大投注。记住，稳扎稳打才能长久盈利！",
      "老手策略：观察走势图，寻找连击机会。当出现连续小奖时，往往是大奖的前兆！",
      "现在正是入场的好时机！刚才连续出了几个小奖，按照经验，大奖马上就要来了！",
      "大家注意看！这个位置已经连续3次没出奖了，按照概率学，下一次中奖率会很高！",
      "我建议大家可以适当加大投注，现在这个时机很难得！",
      "刚才有人问投注策略，我简单说一下：新手建议100-500，老手可以1000-5000，但一定要控制好风险！",
      "VIP用户有专属投注建议，点击我头像查看！",
      "现在这个游戏的中奖率确实很高，大家可以放心跟投！",
      "刚才那个大奖真的很震撼！这就是我们平台的魅力所在！",
      "新用户不用担心，我们有完善的客服体系，24小时在线为您服务！",
      "充值问题？很简单！点击右上角充值按钮，支持微信、支付宝、银行卡等多种方式！",
      "提现速度很快，一般1-3分钟到账，大额提现可能需要人工审核，但不会超过24小时！",
      "我们的平台是正规的，有完整的营业执照和监管，大家可以放心！",
      "有任何问题都可以私信我，我会第一时间回复！",
      "今天的直播就到这里，感谢大家的陪伴！明天同一时间，我们继续！",
      "记得关注我们的直播间，不错过任何精彩内容！",
      "明天还有更大的活动，大家记得来哦！"
    ];

    // APP私信客服机器人（售后客服）话术
    const customerServiceScripts = [
      "您好！我是您的专属客服，有什么可以帮助您的吗？",
      "请问您遇到什么问题了？我会尽快为您解决！",
      "很抱歉给您带来不便，我来帮您处理这个问题。",
      "您的反馈我们已经收到，正在为您核实处理中，请稍等。",
      "这个问题我已经记录下来了，会安排专人跟进，24小时内给您回复。",
      "为了您的账户安全，请提供一下您的注册手机号进行身份验证。",
      "您的提现申请已经提交成功，预计1-3分钟到账，请耐心等待。",
      "充值遇到问题了吗？我来帮您检查一下订单状态。",
      "您的VIP等级是黄金会员，享受专属客服服务和更高提现额度。",
      "很抱歉系统出现故障，技术人员正在紧急修复中，预计10分钟内恢复正常。",
      "您的投诉我们已经收到，会严肃处理相关责任人，给您一个满意的答复。",
      "为了保障您的权益，建议您截图保存相关证据，我们会认真核实。",
      "您的建议很好，我们会认真考虑并改进我们的服务。",
      "感谢您的耐心等待，问题已经解决，您可以正常使用了。",
      "如果您还有其他问题，随时可以联系我，我24小时在线为您服务。",
      "您的账户状态正常，可以正常进行游戏和提现操作。",
      "为了您的安全，建议您定期修改密码，不要告诉他人您的账户信息。",
      "我们平台有完善的风控系统，会保护您的资金安全。",
      "您的游戏记录我都看到了，有什么需要我帮您分析的吗？",
      "建议您合理控制游戏时间，适度娱乐，理性投注。",
      "我们有很多新游戏上线，您可以去游戏大厅看看，说不定有您喜欢的。",
      "您的积分可以兑换很多精美礼品，在积分商城查看详情。",
      "我们定期举办各种活动，关注公告栏，不要错过精彩活动哦！",
      "如果您对我们的服务满意，请给我们一个好评，您的支持是我们前进的动力！",
      "感谢您选择我们的平台，我们会持续改进，为您提供更好的服务！"
    ];

    // 游戏种草机器人（内容营销）话术
    const gamePromotionScripts = [
      "哇！这个新游戏太好玩了！画面精美，玩法新颖，强烈推荐给大家！",
      "我刚玩了这个游戏，中奖率真的很高！新手也能轻松上手！",
      "这个游戏的特色就是连击系统，一旦触发连击，奖金翻倍！太刺激了！",
      "我昨天在这个游戏上赚了5000块！大家快来试试运气！",
      "这个游戏的设计师太有才了！每个细节都做得很用心！",
      "我玩过很多游戏，这个绝对是最好玩的！不信你们试试！",
      "这个游戏有免费试玩功能，大家可以先体验一下再决定是否充值！",
      "我给大家分享一个技巧：在这个位置投注，中奖率会更高！",
      "这个游戏每天都有不同的活动，奖励丰厚，不要错过！",
      "我刚发现这个游戏的隐藏功能，可以解锁更多奖励！",
      "这个游戏的音效和画面都很棒，玩起来很有沉浸感！",
      "我推荐这个游戏给所有朋友，大家都说好玩！",
      "这个游戏支持多种投注方式，满足不同玩家的需求！",
      "我在这游戏上已经连续中奖3天了，今天继续！",
      "这个游戏有排行榜功能，可以和全服玩家比拼！",
      "我刚解锁了这个游戏的新关卡，奖励超级丰厚！",
      "这个游戏的操作很简单，新手也能快速上手！",
      "我给大家展示一下这个游戏的精彩瞬间！",
      "这个游戏有社交功能，可以和朋友一起玩！",
      "我在这游戏上交到了很多朋友，大家一起分享游戏心得！",
      "这个游戏的客服很专业，有问题随时解决！",
      "我推荐这个游戏给所有喜欢刺激的朋友！",
      "这个游戏有完整的教程，新手不用担心不会玩！",
      "我在这游戏上找到了很多乐趣，每天都有新发现！",
      "这个游戏值得长期玩下去，内容很丰富！"
    ];

    // 根据智能体类型选择话术库
    let scripts: string[] = [];
    switch (agentType) {
      case '客服':
        scripts = customerServiceScripts;
        break;
      case '产品介绍':
        scripts = hostScripts;
        break;
      case '情感交流':
        scripts = liveRoomScripts;
        break;
      case '游戏种草':
        scripts = gamePromotionScripts;
        break;
      default:
        scripts = [...liveRoomScripts, ...hostScripts, ...customerServiceScripts, ...gamePromotionScripts];
    }

    // 根据用户消息内容智能选择回复
    if (lowerMessage.includes('你好') || lowerMessage.includes('hello') || lowerMessage.includes('hi')) {
      return scripts.find(s => s.includes('你好') || s.includes('欢迎') || s.includes('您好')) || scripts[0];
    }
    if (lowerMessage.includes('怎么玩') || lowerMessage.includes('玩法') || lowerMessage.includes('规则')) {
      return scripts.find(s => s.includes('玩法') || s.includes('规则') || s.includes('介绍')) || scripts[Math.floor(Math.random() * scripts.length)];
    }
    if (lowerMessage.includes('充值') || lowerMessage.includes('提现') || lowerMessage.includes('钱')) {
      return scripts.find(s => s.includes('充值') || s.includes('提现') || s.includes('优惠')) || scripts[Math.floor(Math.random() * scripts.length)];
    }
    if (lowerMessage.includes('中奖') || lowerMessage.includes('赢了') || lowerMessage.includes('赚了')) {
      return scripts.find(s => s.includes('中奖') || s.includes('赢了') || s.includes('赚了')) || scripts[Math.floor(Math.random() * scripts.length)];
    }
    if (lowerMessage.includes('问题') || lowerMessage.includes('帮助') || lowerMessage.includes('客服')) {
      return scripts.find(s => s.includes('问题') || s.includes('帮助') || s.includes('客服')) || scripts[Math.floor(Math.random() * scripts.length)];
    }

    // 随机返回话术
    return scripts[Math.floor(Math.random() * scripts.length)];
  };

  // 发送测试消息
  const handleSendMessage = async () => {
    if (!userInput.trim()) {
      message.warning('请输入测试消息');
      return;
    }
    
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      const botResponse = getBotResponse(userInput, selectedAgent);
      
      const newMessage = {
        id: Date.now(),
        user: userInput,
        bot: botResponse,
        timestamp: new Date().toLocaleTimeString(),
        agent: selectedAgent,
        responseTime: Math.random() * 2 + 0.5,
      };
      
      setConversationHistory(prev => [...prev, newMessage]);
      setUserInput('');
      message.success('消息发送成功！');
    } catch (error) {
      message.error('发送失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // 清空对话历史
  const handleClearHistory = () => {
    setConversationHistory([]);
    message.info('对话历史已清空');
  };

  // 导出对话记录
  const handleExportConversation = async () => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      message.success('对话记录导出成功！');
    } catch (error) {
      message.error('导出失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  // 运行A/B测试
  const handleRunABTest = async () => {
    setAbTestProgress(0);
    setCurrentStep(0);
    
    const steps = [
      { step: 0, title: '初始化测试环境', status: 'process' },
      { step: 1, title: '分配用户组', status: 'process' },
      { step: 2, title: '执行测试用例', status: 'process' },
      { step: 3, title: '收集测试数据', status: 'process' },
      { step: 4, title: '生成测试报告', status: 'finish' },
    ];
    
    for (let i = 0; i < steps.length; i++) {
      await new Promise(resolve => setTimeout(resolve, 1200));
      setCurrentStep(i);
      setAbTestProgress((i + 1) * 20);
    }
    
    message.success('A/B测试完成！');
  };

  // 查看调用链路
  const handleViewTrace = (record: any) => {
    setTraceModalVisible(true);
  };

  // 保存调试设置
  const handleSaveSettings = async (values: any) => {
    setLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 1000));
      message.success('调试设置保存成功！');
      setSettingsModalVisible(false);
    } catch (error) {
      message.error('保存失败，请重试');
    } finally {
      setLoading(false);
    }
  };

  const debugStats = [
    { title: '今日测试次数', value: 156, icon: <BugOutlined /> },
    { title: 'A/B测试进行中', value: 3, icon: <BarChartOutlined /> },
    { title: '平均响应时间', value: '1.2s', icon: <ApiOutlined /> },
    { title: '测试成功率', value: '96.8%', icon: <BugOutlined /> },
  ];

  const traceData = [
    {
      step: 1,
      name: '接收用户输入',
      status: 'success',
      duration: '0.1s',
      details: '用户输入: "你好，我想了解一下游戏规则"',
    },
    {
      step: 2,
      name: '意图识别',
      status: 'success',
      duration: '0.3s',
      details: '识别意图: 游戏咨询',
    },
    {
      step: 3,
      name: '智能体选择',
      status: 'success',
      duration: '0.2s',
      details: '选择智能体: 游戏介绍Bot',
    },
    {
      step: 4,
      name: '知识库查询',
      status: 'success',
      duration: '0.4s',
      details: '查询相关游戏规则知识',
    },
    {
      step: 5,
      name: '生成回复',
      status: 'success',
      duration: '0.8s',
      details: '生成回复内容',
    },
    {
      step: 6,
      name: '返回结果',
      status: 'success',
      duration: '0.1s',
      details: '返回给用户',
    },
  ];

  const abTestData = [
    {
      id: 1,
      name: '话术A/B测试',
      description: '测试不同话术的转化效果',
      status: 'running',
      traffic: 50,
      startTime: '2025-10-20',
      participants: 1256,
    },
    {
      id: 2,
      name: '智能体选择测试',
      description: '测试不同智能体的响应效果',
      status: 'completed',
      traffic: 30,
      startTime: '2025-10-15',
      participants: 856,
    },
  ];

  return (
    <div>
      <div className="page-header">
        <h1>调试工具</h1>
        <p>所见即所得调试，快速调试完整对话功能，支持A/B验证和调用链路追踪</p>
      </div>

      {/* 统计卡片 */}
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        {debugStats.map((stat, index) => (
          <Col xs={24} sm={12} lg={6} key={index}>
            <Card>
              <div className="stats-card">
                <div style={{ fontSize: 32, color: '#1890ff', marginBottom: 8 }}>
                  {stat.icon}
                </div>
                <div className="stats-number">{stat.value}</div>
                <div className="stats-label">{stat.title}</div>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[16, 16]}>
        {/* 对话模拟器 */}
        <Col xs={24} lg={12}>
          <Card
            title="对话模拟器"
            extra={
              <Space>
                <Tooltip title="导出对话记录">
                  <Button icon={<ExportOutlined />} onClick={handleExportConversation}>
                    导出
                  </Button>
                </Tooltip>
                <Tooltip title="清空对话历史">
                  <Button icon={<ReloadOutlined />} onClick={handleClearHistory}>
                    清空
                  </Button>
                </Tooltip>
                <Tooltip title="查看调用链路">
                  <Button icon={<EyeOutlined />} onClick={() => setTraceModalVisible(true)}>
                    查看链路
                  </Button>
                </Tooltip>
                <Tooltip title="调试设置">
                  <Button icon={<SettingOutlined />} onClick={() => setSettingsModalVisible(true)}>
                    设置
                  </Button>
                </Tooltip>
              </Space>
            }
          >
            <div style={{ marginBottom: 16 }}>
              <div className="debug-console" style={{ 
                height: 300, 
                marginBottom: 16, 
                border: '1px solid #d9d9d9', 
                borderRadius: '6px',
                padding: '12px',
                backgroundColor: '#fafafa',
                overflow: 'auto'
              }}>
                {conversationHistory.map((msg) => (
                  <div key={msg.id} style={{ marginBottom: '12px' }}>
                    <div style={{ 
                      fontSize: '12px', 
                      color: '#666', 
                      marginBottom: '4px',
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}>
                      <span>用户: {msg.user}</span>
                      <span>{msg.timestamp}</span>
                    </div>
                    <div style={{ 
                      backgroundColor: '#e6f7ff', 
                      padding: '8px 12px', 
                      borderRadius: '6px',
                      marginBottom: '8px'
                    }}>
                      {msg.user}
                    </div>
                    <div style={{ 
                      fontSize: '12px', 
                      color: '#666', 
                      marginBottom: '4px',
                      display: 'flex',
                      justifyContent: 'space-between'
                    }}>
                      <span>AI回复 (智能体: {msg.agent})</span>
                      <span>响应时间: {msg.responseTime.toFixed(2)}s</span>
                    </div>
                    <div style={{ 
                      backgroundColor: '#f6ffed', 
                      padding: '8px 12px', 
                      borderRadius: '6px'
                    }}>
                      {msg.bot}
                    </div>
                  </div>
                ))}
                {conversationHistory.length === 0 && (
                  <div style={{ textAlign: 'center', color: '#999', padding: 50 }}>
                    开始对话测试...
                  </div>
                )}
              </div>
              
              <div style={{ marginBottom: 16 }}>
                <Space>
                  <Select
                    value={selectedAgent}
                    onChange={setSelectedAgent}
                    style={{ width: 180 }}
                    placeholder="选择智能体"
                  >
                    <Select.Option value="all">全部智能体</Select.Option>
                    <Select.Option value="客服">APP私信客服机器人</Select.Option>
                    <Select.Option value="产品介绍">主播带单机器人</Select.Option>
                    <Select.Option value="情感交流">直播间活跃机器人</Select.Option>
                    <Select.Option value="游戏种草">游戏种草机器人</Select.Option>
                  </Select>
                  <Radio.Group value={testMode} onChange={(e) => setTestMode(e.target.value)}>
                    <Radio value="single">单次测试</Radio>
                    <Radio value="batch">批量测试</Radio>
                  </Radio.Group>
                </Space>
              </div>
              
              <Space.Compact style={{ width: '100%' }}>
                <Input
                  placeholder="输入测试消息..."
                  value={userInput}
                  onChange={(e) => setUserInput(e.target.value)}
                  onPressEnter={handleSendMessage}
                  disabled={loading}
                />
                <Button 
                  type="primary" 
                  icon={<SendOutlined />} 
                  onClick={handleSendMessage}
                  loading={loading}
                >
                  发送
                </Button>
              </Space.Compact>
            </div>
          </Card>
        </Col>

        {/* A/B测试 */}
        <Col xs={24} lg={12}>
          <Card
            title="A/B测试"
            extra={
              <Space>
                <Tooltip title="运行A/B测试">
                  <Button icon={<PlayCircleOutlined />} onClick={handleRunABTest}>
                    运行测试
                  </Button>
                </Tooltip>
                <Tooltip title="创建A/B测试">
                  <Button type="primary" icon={<BarChartOutlined />} onClick={() => setAbTestModalVisible(true)}>
                    创建测试
                  </Button>
                </Tooltip>
              </Space>
            }
          >
            <List
              size="small"
              dataSource={abTestData}
              renderItem={(item) => (
                <List.Item
                  actions={[
                    <Tooltip title="查看测试详情">
                      <Button type="link" size="small" onClick={() => message.info('查看测试详情功能开发中...')}>
                        查看
                      </Button>
                    </Tooltip>,
                    <Tooltip title="编辑测试">
                      <Button type="link" size="small" onClick={() => message.info('编辑测试功能开发中...')}>
                        编辑
                      </Button>
                    </Tooltip>,
                    <Tooltip title="导出测试报告">
                      <Button type="link" size="small" icon={<DownloadOutlined />} onClick={() => message.info('导出测试报告功能开发中...')}>
                        导出
                      </Button>
                    </Tooltip>,
                  ]}
                >
                  <List.Item.Meta
                    title={
                      <Space>
                        <span>{item.name}</span>
                        <Tag color={item.status === 'running' ? 'green' : 'blue'}>
                          {item.status === 'running' ? '进行中' : '已完成'}
                        </Tag>
                      </Space>
                    }
                    description={
                      <div>
                        <div>{item.description}</div>
                        <div style={{ marginTop: 4 }}>
                          <Space>
                            <span>流量分配: {item.traffic}%</span>
                            <span>参与人数: {item.participants}</span>
                            <span>开始时间: {item.startTime}</span>
                          </Space>
                        </div>
                      </div>
                    }
                  />
                </List.Item>
              )}
            />
          </Card>
        </Col>

        {/* 调用链路追踪 */}
        <Col xs={24}>
          <Card title="调用链路追踪" extra={<Button type="link">查看全部</Button>}>
            <Timeline
              items={traceData.map((item) => ({
                color: item.status === 'success' ? 'green' : 'red',
                children: (
                  <div className="trace-step">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <div>
                        <div style={{ fontWeight: 'bold' }}>{item.name}</div>
                        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                          {item.details}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <Tag color={item.status === 'success' ? 'green' : 'red'}>
                          {item.status === 'success' ? '成功' : '失败'}
                        </Tag>
                        <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>
                          {item.duration}
                        </div>
                      </div>
                    </div>
                  </div>
                ),
              }))}
            />
          </Card>
        </Col>
      </Row>

      {/* 链路追踪详情模态框 */}
      <Modal
        title="调用链路详情"
        open={traceModalVisible}
        onCancel={() => setTraceModalVisible(false)}
        width={800}
        footer={[
          <Button key="close" onClick={() => setTraceModalVisible(false)}>
            关闭
          </Button>,
        ]}
      >
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab="链路图" key="1">
            <div style={{ height: 400, background: '#f5f5f5', borderRadius: 8, padding: 16 }}>
              <div style={{ textAlign: 'center', padding: 50, color: '#999' }}>
                <ApiOutlined style={{ fontSize: 48, marginBottom: 16 }} />
                <div>调用链路可视化图</div>
                <div style={{ fontSize: 12 }}>显示完整的调用链路和依赖关系</div>
              </div>
            </div>
          </Tabs.TabPane>
          <Tabs.TabPane tab="性能分析" key="2">
            <Row gutter={16}>
              <Col span={8}>
                <Statistic title="总耗时" value="1.9s" />
              </Col>
              <Col span={8}>
                <Statistic title="最慢步骤" value="生成回复" />
              </Col>
              <Col span={8}>
                <Statistic title="成功率" value="100%" />
              </Col>
            </Row>
            <Divider />
            <div>
              <h4>步骤详情</h4>
              <List
                size="small"
                dataSource={traceData}
                renderItem={(item) => (
                  <List.Item>
                    <List.Item.Meta
                      title={item.name}
                      description={
                        <Space>
                          <span>耗时: {item.duration}</span>
                          <Tag color={item.status === 'success' ? 'green' : 'red'}>
                            {item.status === 'success' ? '成功' : '失败'}
                          </Tag>
                        </Space>
                      }
                    />
                  </List.Item>
                )}
              />
            </div>
          </Tabs.TabPane>
        </Tabs>
      </Modal>

      {/* A/B测试创建模态框 */}
      <Modal
        title="创建A/B测试"
        open={abTestModalVisible}
        onCancel={() => setAbTestModalVisible(false)}
        width={600}
        footer={[
          <Button key="cancel" onClick={() => setAbTestModalVisible(false)}>
            取消
          </Button>,
          <Button key="create" type="primary">
            创建
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 16 }}>
          <label>测试名称：</label>
          <Input placeholder="输入测试名称" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>测试描述：</label>
          <TextArea rows={3} placeholder="输入测试描述" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>流量分配：</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <span>A组: 50%</span>
            <span>B组: 50%</span>
          </div>
        </div>
        <div>
          <label>测试指标：</label>
          <div>
            <input type="checkbox" /> 转化率
            <input type="checkbox" /> 用户满意度
            <input type="checkbox" /> 响应时间
          </div>
        </div>
      </Modal>

      {/* 调试设置模态框 */}
      <Modal
        title="调试设置"
        open={settingsModalVisible}
        onCancel={() => setSettingsModalVisible(false)}
        width={600}
        footer={[
          <Button key="cancel" onClick={() => setSettingsModalVisible(false)}>
            取消
          </Button>,
          <Button
            key="save"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            保存设置
          </Button>
        ]}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSaveSettings}
        >
          <Form.Item
            name="debugLevel"
            label="调试级别"
            initialValue="info"
          >
            <Select>
              <Select.Option value="debug">Debug</Select.Option>
              <Select.Option value="info">Info</Select.Option>
              <Select.Option value="warn">Warning</Select.Option>
              <Select.Option value="error">Error</Select.Option>
            </Select>
          </Form.Item>
          
          <Form.Item
            name="responseTimeout"
            label="响应超时时间(秒)"
            initialValue={30}
          >
            <InputNumber min={5} max={300} style={{ width: '100%' }} />
          </Form.Item>
          
          <Form.Item
            name="enableTrace"
            label="启用调用链路追踪"
            valuePropName="checked"
            initialValue={true}
          >
            <Switch />
          </Form.Item>
          
          <Form.Item
            name="enableMetrics"
            label="启用性能指标收集"
            valuePropName="checked"
            initialValue={true}
          >
            <Switch />
          </Form.Item>
          
          <Form.Item
            name="logRetention"
            label="日志保留天数"
            initialValue={7}
          >
            <InputNumber min={1} max={30} style={{ width: '100%' }} />
          </Form.Item>
        </Form>
      </Modal>

      {/* A/B测试运行模态框 */}
      <Modal
        title="A/B测试运行"
        open={abTestModalVisible}
        onCancel={() => setAbTestModalVisible(false)}
        width={800}
        footer={[
          <Button key="close" onClick={() => setAbTestModalVisible(false)}>
            关闭
          </Button>,
          <Button 
            key="run" 
            type="primary" 
            icon={<BarChartOutlined />}
            onClick={handleRunABTest}
            loading={loading}
          >
            运行测试
          </Button>
        ]}
      >
        <div>
          <Alert
            message="A/B测试配置"
            description="配置测试参数，系统将自动分配用户组并收集测试数据。"
            type="info"
            style={{ marginBottom: 16 }}
          />
          
          <Form layout="vertical">
            <Form.Item label="测试名称">
              <Input placeholder="输入测试名称" />
            </Form.Item>
            
            <Form.Item label="测试描述">
              <Input.TextArea rows={3} placeholder="输入测试描述" />
            </Form.Item>
            
            <Form.Item label="流量分配">
              <Row gutter={16}>
                <Col span={12}>
                  <Input.Group compact>
                    <Input style={{ width: '30%' }} defaultValue="A组" disabled />
                    <InputNumber style={{ width: '70%' }} defaultValue={50} min={0} max={100} />
                  </Input.Group>
                </Col>
                <Col span={12}>
                  <Input.Group compact>
                    <Input style={{ width: '30%' }} defaultValue="B组" disabled />
                    <InputNumber style={{ width: '70%' }} defaultValue={50} min={0} max={100} />
                  </Input.Group>
                </Col>
              </Row>
            </Form.Item>
            
            <Form.Item label="测试指标">
              <Select mode="multiple" placeholder="选择测试指标">
                <Select.Option value="response_time">响应时间</Select.Option>
                <Select.Option value="satisfaction">用户满意度</Select.Option>
                <Select.Option value="conversion">转化率</Select.Option>
                <Select.Option value="retention">留存率</Select.Option>
              </Select>
            </Form.Item>
          </Form>
          
          <Steps
            current={currentStep}
            items={[
              { title: '初始化测试环境' },
              { title: '分配用户组' },
              { title: '执行测试用例' },
              { title: '收集测试数据' },
              { title: '生成测试报告' },
            ]}
            style={{ marginTop: 24 }}
          />
          
          <div style={{ textAlign: 'center', marginTop: 24 }}>
            <Progress
              type="circle"
              percent={abTestProgress}
              format={() => `${abTestProgress}%`}
            />
          </div>
          
          {abTestProgress === 100 && (
            <Alert
              message="测试完成"
              description="A/B测试已成功完成，可以查看测试报告和结果分析。"
              type="success"
              style={{ marginTop: 16 }}
            />
          )}
        </div>
      </Modal>
    </div>
  );
};

export default DebugTools;
